<template>
    <div class="message-box">
        <!-- <headerNav title="消息详情" /> -->
        <div :class="(noticeType == '1' && messageType != '33') ? 'center' : 'center centerS'">
            <div class="card title">
                <div class="text-code">{{ basicInfo.finaleContract }}</div>
                <div class="text-content">
                    {{ approvalContent.variables.businessName }}
                    <span v-if="!approvalContent.variables.cancel">
                        <van-tag v-if="noticeType == '1'" type="warning" plain>待审核</van-tag>
                        <van-tag v-if="noticeType == '2'" type="success" plain>已同意</van-tag>
                        <van-tag v-if="noticeType == '3'" type="danger" plain>已拒绝</van-tag>
                    </span>
                    <van-tag v-else color="#4A7DFF" plain>已撤销</van-tag>
                </div>
            </div>
            <div class="card" v-if="!approvalContent.variables.var11 
                    || (approvalContent.variables.var11 !== '中期款' && approvalContent.variables.var11 !== '尾期款' 
                    && approvalContent.variables.var11 !== '尾期后变更款' && approvalContent.variables.var11 !== '增项款交款（一）' 
                    && approvalContent.variables.var11 !== '增项款交款（二）')">
                <div class="approval-top">
                    <div class="approval-content">申请信息</div>
                    <div class="approval-time">{{ approvalContent.createDate }}</div>
                </div>
                <div class="approval-center">
                    <div class="item">
                        <div class="item-title">申请人：</div>
                        <div class="item-text">{{ approvalContent.startTaskUserName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">申请名称：</div>
                        <div class="item-text">{{ approvalContent.variables.businessName }}</div>
                    </div>
                    <!-- 优惠申请/设计费 -->
                    <div class="item" v-if="businessType == '2' || businessType == '12'">
                        <div class="item-title">优惠金额：</div>
                        <div class="item-text">{{ businessType == '2' ? approvalContent.variables.var1 :
                            approvalContent.variables.var3 }}</div>
                    </div>
                    <!-- 飞单 -->
                    <div class="item" v-if="businessType == '3' || businessType == '4'">
                        <div class="item-title">退款金额：</div>
                        <div class="item-text money">{{ approvalContent.variables.var1 }}</div>
                    </div>
                    <!-- 充值金额 -->
                    <div class="item" v-if="businessType == '5'">
                        <div class="item-title">充值金额：</div>
                        <div class="item-text">{{ approvalContent.variables.var1 }}</div>
                    </div>
                    <!-- 充值金额 -->
                    <div class="item" v-if="businessType == '1'">
                        <div class="item-title">款项金额：</div>
                        <div class="item-text">{{ approvalContent.variables.var1 }}</div>
                    </div>
                    <!-- 充值金额 -->
                    <div class="item" v-if="businessType == '6'">
                        <div class="item-title">商品名称：</div>
                        <div class="item-text">{{ approvalContent.variables.var1 }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">申请类别：</div>
                        <div class="item-text">{{ approvalContent.procDefName }}</div>
                    </div>
                    <div class="item" v-if="businessType == '1'">
                        <div class="item-title">款项类型：</div>
                        <div class="item-text">{{ approvalContent.variables.var1 }}</div>
                    </div>
                    <div class="item" v-if="businessType == '2'">
                        <div class="item-title">金额备注：</div>
                        <div class="item-text">{{ approvalContent.variables.var2 }}</div>
                    </div>
                    <div class="item" v-if="['39', '44'].indexOf(businessType) < 0">
                        <div class="item-title">申请理由：</div>
                        <div class="item-text"
                            v-if="businessType == '3' || businessType == '4' || businessType == '12'">
                            {{ businessType == '12' ? approvalContent.variables.var6 : approvalContent.variables.var2 }}
                        </div>
                        <div class="item-text" v-if="businessType == '0'">{{ approvalContent.variables.var1 }}</div>
                        <div class="item-text" v-if="businessType == '11'">{{ approvalContent.variables.var3 }}</div>
                        <div class="item-text" v-if="businessType == '19'">{{ approvalContent.variables.refundRemark }}
                        </div>
                        <div class="item-text" v-if="businessType == '40'">{{ approvalContent.variables.remark }}</div>
                    </div>
                </div>
            </div>
            <div class="card1" v-if="approvalContent.variables.var11 
                    || approvalContent.variables.var11 === '中期款' || approvalContent.variables.var11 === '尾期款' 
                    || approvalContent.variables.var11 === '尾期后变更款' || approvalContent.variables.var11 === '增项款交款（一）' 
                    || approvalContent.variables.var11 === '增项款交款（二）'">
                <div class="approval-top">
                    <div class="approval-content">申请详情</div>
                    <div class="approval-time">{{ approvalContent.createDate }}</div>
                </div>
                 <div class="approval-center">
                    <div class="item">
                        <div class="item-title">申请人：</div>
                        <div class="item-text">{{ approvalContent.startTaskUserName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">申请名称：</div>
                        <div class="item-text">{{ approvalContent.variables.businessName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">申请类别：</div>
                        <div class="item-text">{{ approvalContent.procDefName }}</div>
                    </div>
                    <div class="item" v-if="['39', '44'].indexOf(businessType) < 0">
                        <div class="item-title">申请理由：</div>
                        <div class="item-text"
                            v-if="businessType == '3' || businessType == '4' || businessType == '12'">
                            {{ businessType == '12' ? approvalContent.variables.var6 : approvalContent.variables.var2 }}
                        </div>
                        <div class="item-text" v-if="businessType == '0'">{{ approvalContent.variables.var1 }}</div>
                        <div class="item-text" v-if="businessType == '11'">{{ approvalContent.variables.var3 }}</div>
                        <div class="item-text" v-if="businessType == '19'">{{ approvalContent.variables.refundRemark }}
                        </div>
                        <div class="item-text" v-if="businessType == '40'">{{ approvalContent.variables.remark }}</div>
                    </div>
                </div>
            </div>
            <!-- 辅材信息 -->
            <div v-if="businessType == '11'" class="card">
                <div class="data-top">
                    <div class="data-content">辅材信息</div>
                </div>
                <div>
                    <div class="list-item" v-for="(item, index) in materialsList">
                        <van-image class="left" :src="item.imgUrl ? item.imgUrl : require('@/assets/imgNull.png')"
                            @click="photoPreview(materialsList,index)" />
                        <div class="item-center">
                            <div class="item-top">
                                <div class="top-name">{{ item.itemName }}</div>
                                <div class="item-right">{{ item.itemQty }}</div>
                            </div>
                            <div class="item-bottom">
                                <div>{{ item.modelSpec }}</div>
                                <div class="item-right">{{ item.unitName }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" 
                    v-if="!['5', '61', '68', '69', '70', '71','79'].includes(businessType) 
                    && (!approvalContent.variables.var11 
                    || (approvalContent.variables.var11 !== '中期款' && approvalContent.variables.var11 !== '尾期款' 
                    && approvalContent.variables.var11 !== '尾期后变更款' && approvalContent.variables.var11 !== '增项款交款（一）' 
                    && approvalContent.variables.var11 !== '增项款交款（二）'))">
                <div class="data-top" @click="() => isShowData = !isShowData">
                    <div class="data-content" id="common-basic-info-845782">基本资料</div>
                    <div class="data-icon">
                        <van-icon v-if="!isShowData" size="14px" name="arrow-down" />
                        <van-icon v-else size="14px" name="arrow-up" />
                    </div>
                </div>
                <div v-if="isShowData">
                    <!-- 充值申请 -->
                    <!-- <div v-if="businessType == '5'">
                        <div class="item">
                            <div class="item-title">账号ID：</div>
                            <div class="item-text">{{ basicInfo.consumerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">账号名称：</div>
                            <div class="item-text">{{ basicInfo.finaleContract }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">渠道：</div>
                            <div class="item-text">{{ basicInfo.gradeCode }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">运营人：</div>
                            <div class="item-text">{{ basicInfo.createDate }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">账户累计消耗：</div>
                            <div class="item-text">{{ basicInfo.channelName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">账户累计充值：</div>
                            <div class="item-text">{{ basicInfo.areaQty }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">账户余额：</div>
                            <div class="item-text">{{ basicInfo.orderProcess }}</div>
                        </div>
                    </div> -->
                    <!-- 完工申请/障碍单审批 -->
                    <div class="content" v-if="businessType == '0' || businessType == '8'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ basicInfo.consumerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ basicInfo.finaleContract }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">渠道：</div>
                            <div class="item-text">{{ basicInfo.channelName }}</div>
                        </div>
                        <div class="item" v-if="businessType == '0'">
                            <div class="item-title">客户等级：</div>
                            <div class="item-text">{{ basicInfo.gradeCode }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修面积：</div>
                            <div class="item-text">{{ basicInfo.areaQty }}</div>
                        </div>
                        <div class="item" v-if="businessType == '8'">
                            <div class="item-title">区域：</div>
                            <div class="item-text">{{ basicInfo.cityCode }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">详细地址：</div>
                            <div class="item-text">{{ basicInfo.detailAddress }}</div>
                        </div>
                        <!-- <div class="item" v-if="businessType == '8'">
                            <div class="item-title">工期：</div>
                            <div class="item-text">{{ basicInfo.orderProcess }}</div>
                        </div>
                        <div class="item" v-if="businessType == '8'">
                            <div class="item-title">应完工日期：</div>
                            <div class="item-text">{{ basicInfo.collected }}</div>
                        </div> -->
                        <div class="item">
                            <div class="item-title">已交金额：</div>
                            <div class="item-text">{{ basicInfo.collected }}</div>
                        </div>
                    </div>
                    <!-- 辅料申领/辅料申领-->
                    <div class="content content19" v-else-if="businessType == '11'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ materialApplyInfo.consumerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ materialApplyInfo.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">面积：</div>
                            <div class="item-text">{{ materialApplyInfo.areaQty }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">工程状态：</div>
                            <div class="item-text">{{ materialApplyInfo.constructionStatusName }}</div>
                        </div>
                      
                        <div class="item">
                            <div class="item-title">工程进度：</div>
                            <div class="item-text">{{ materialApplyInfo.processLibName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">收款进度：</div>
                            <div class="item-text">{{ materialApplyInfo.feeTypeName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">套餐包：</div>
                            <div class="item-text">{{ materialApplyInfo.templatePackageLevelNames ? materialApplyInfo.templatePackageLevelNames.replace(/,/g, '、') : '' }}</div>
                        </div>
                    </div>
                    <!-- 自理销售退款 -->
                    <div class="content content19" v-else-if="businessType == '19'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ basicInfo.consumerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ basicInfo.maintainContract }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">联系方式：</div>
                            <div class="item-text">{{ basicInfo.phoneNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ basicInfo.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">规划设计师：</div>
                            <div class="item-text">{{ basicInfo.transferName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">预审员：</div>
                            <div class="item-text">{{ basicInfo.budgetName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">深化设计师：</div>
                            <div class="item-text">{{ basicInfo.deepenName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">下单员：</div>
                            <div class="item-text">{{ basicInfo.productName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">督导：</div>
                            <div class="item-text">{{ basicInfo.supervisorName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">项目经理：</div>
                            <div class="item-text">{{ basicInfo.projectName }}</div>
                        </div>
                    </div>
                    <!-- 工程单分配变更业务任务流程 -->
                    <div v-else-if="businessType == '39'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">面积：</div>
                            <div class="item-text">{{ approvalContent.variables.areaAty }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">订单类型：</div>
                            <div class="item-text">{{ approvalContent.variables.orderPriceType == '1' ? '套餐' : '半包' }}
                            </div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '40'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '41'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title" style="width: 125px;">预计开工日期：</div>
                            <div class="item-text">{{ approvalContent.variables.planStartDate }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '42'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">面积：</div>
                            <div class="item-text">{{ approvalContent.variables.areaAty }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">订单类型：</div>
                            <div class="item-text">{{ approvalContent.variables.orderPriceType == '1' ? '套餐' : '半包' }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="item-title">工程计划：</div>
                            <div class="item-text">{{ approvalContent.variables.planName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">工期：</div>
                            <div class="item-text">{{ approvalContent.variables.durationDays }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '43'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '44'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '45'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">应完工日期：</div>
                            <div class="item-text">{{ approvalContent.variables.targetFinishDate }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '46'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">应竣工日期：</div>
                            <div class="item-text">{{ approvalContent.variables.targetCompletedDate }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '47'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">应交付日期：</div>
                            <div class="item-text">{{ approvalContent.variables.targetTransferDate }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '48'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '49' || businessType == '52'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '51'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">工序名称</div>
                            <div class="item-text">{{ approvalContent.variables.processName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">预计完成</div>
                            <div class="item-text">{{ approvalContent.variables.plannedEndTime }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">实际完成</div>
                            <div class="item-text">{{ approvalContent.variables.actualEndTime }}</div>
                        </div>
                    </div>
                    <div v-else-if="businessType == '53'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">工序</div>
                            <div class="item-text">{{ approvalContent.variables.feeTypeName }}</div>
                        </div>
                    </div>
                    <div
                        v-else-if="businessType == '54' || businessType == '57' || businessType == '56' || businessType == '55'">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ approvalContent.variables.customerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ approvalContent.variables.contractNo }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ approvalContent.variables.detailAddress }}</div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ basicInfo.consumerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ basicInfo.finaleContract }}</div>
                        </div>
                        <!-- 不是收款计划或者解锁申请时展示 -->
                        <div class="item" v-if="businessType != '1' && businessType != '7' && businessType != '11'">
                            <div class="item-title">客户等级：</div>
                            <div class="item-text">{{ basicInfo.gradeCode }}</div>
                        </div>
                        <div class="item" v-if="businessType != '11'">
                            <div class="item-title">签单时间：</div>
                            <div class="item-text">{{ basicInfo.createDate }}</div>
                        </div>
                        <div class="item" v-if="businessType != '11'">
                            <div class="item-title">渠道：</div>
                            <div class="item-text">{{ basicInfo.channelName }}</div>
                        </div>
                        <div class="item" v-if="businessType != '11'">
                            <div class="item-title">装修面积：</div>
                            <div class="item-text">{{ basicInfo.areaQty }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">区域：</div>
                            <div class="item-text">{{ basicInfo.cityCode }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">详细地址：</div>
                            <div class="item-text">{{ basicInfo.detailAddress }}</div>
                        </div>
                        <div class="item" v-if="businessType != '11'">
                            <div class="item-title">订单进度：</div>
                            <div class="item-text">{{ basicInfo.orderProcess }}</div>
                        </div>
                        <div class="item" v-if="businessType != '11'">
                            <div class="item-title">已交金额：</div>
                            <div class="item-text">{{ basicInfo.collected }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '1' && approvalContent.variables.var11 
                    && (approvalContent.variables.var11 === '中期款' || approvalContent.variables.var11 === '尾期款' 
                    || approvalContent.variables.var11 === '尾期后变更款' || approvalContent.variables.var11 === '增项款交款（一）' 
                    || approvalContent.variables.var11 === '增项款交款（二）')">
                <div class="data-top" @click="() => isShowData = !isShowData">
                    <div class="data-content">基本资料</div>
                    <div class="data-icon">
                        <van-icon v-if="!isShowData" size="14px" name="arrow-down" />
                        <van-icon v-else size="14px" name="arrow-up" />
                    </div>
                </div>
                <div v-if="isShowData">
                    <div class="item">
                        <div class="item-title1">客户</div>
                        <div class="item-text">{{ basicInfo.consumerName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title1">合同号</div>
                        <div class="item-text">{{ basicInfo.finaleContract }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title1">装修地址</div>
                        <div class="item-text">{{ basicInfo.detailAddress }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 
                        || approvalContent.variables.var11 === '中期款' || approvalContent.variables.var11 === '尾期款' 
                        || approvalContent.variables.var11 === '尾期后变更款' || approvalContent.variables.var11 === '增项款交款（一）' 
                        || approvalContent.variables.var11 === '增项款交款（二）'">
                        <div class="item-title1">套餐</div>
                        <div class="item-text">{{ planDetail.budgetTemplateName }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 
                        || approvalContent.variables.var11 === '中期款' || approvalContent.variables.var11 === '尾期款' 
                        || approvalContent.variables.var11 === '尾期后变更款' || approvalContent.variables.var11 === '增项款交款（一）' 
                        || approvalContent.variables.var11 === '增项款交款（二）'">
                        <div class="item-title1">工程合同价</div>
                        <div class="item-text">{{ planDetail.contractPrice }}</div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '39'">
                <div class="data-top">
                    <div class="data-content">分配信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">分配人：</div>
                        <div class="item-text">{{ approvalContent.variables.assignerName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">分配原因：</div>
                        <div class="item-text">{{ approvalContent.variables.assignableCause }}</div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '41'">
                <div class="data-top">
                    <div class="data-content">延期开工信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title" style="width:125px">延期开工天数：</div>
                        <div class="item-text">{{ approvalContent.variables.delayDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (approvalContent.variables.picInfo?.split(',') || [])"
                                :src="imgItem"
                                @click="photoPreview((approvalContent.variables.picInfo?.split(',') || []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '42'">
                <div class="data-top">
                    <div class="data-content">开工信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">开工时间：</div>
                        <div class="item-text">{{ approvalContent.variables.startDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">实际工期：</div>
                        <div class="item-text">{{ approvalContent.variables.durationDays }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (approvalContent.variables.picInfo?.split(',') || [])"
                                :src="imgItem"
                                @click="photoPreview((approvalContent.variables.picInfo?.split(',') || []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '43'">
                <div class="data-top">
                    <div class="data-content">开工信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">开工天数：</div>
                        <div class="item-text">{{ approvalContent.variables.startDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (approvalContent.variables.picInfo?.split(',') || [])"
                                :src="imgItem"
                                @click="photoPreview((approvalContent.variables.picInfo?.split(',') || []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '44'">
                <div class="data-top">
                    <div class="data-content">退回信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">退回原因：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (approvalContent.variables.picInfo?.split(',') || [])"
                                :src="imgItem"
                                @click="photoPreview((approvalContent.variables.picInfo?.split(',') || []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '45'">
                <div class="data-top">
                    <div class="data-content">完工信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">完工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.completionDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">完工备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">完工单图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (JSON.parse(approvalContent.variables.picInfo) || [])"
                                :src="imgItem.fileUrl"
                                @click="photoPreview((JSON.parse(approvalContent.variables.picInfo) || []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '46'">
                <div class="data-top">
                    <div class="data-content">俊工信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">俊工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.completionDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">俊工备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">竣工单图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (JSON.parse(approvalContent.variables.picInfo) || [])"
                                :src="imgItem.fileUrl"
                                @click="photoPreview((JSON.parse(approvalContent.variables.picInfo) || []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '47'">
                <div class="data-top">
                    <div class="data-content">结转信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">完成日期：</div>
                        <div class="item-text">{{ approvalContent.variables.completionDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (JSON.parse(approvalContent.variables.picInfo) || [])"
                                :src="imgItem.fileUrl"
                                @click="photoPreview((JSON.parse(approvalContent.variables.picInfo) || []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '48'">
                <div class="data-top">
                    <div class="data-content">延期信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">延期工序：</div>
                        <div class="item-text">{{ approvalContent.variables.processName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">延期天数：</div>
                        <div class="item-text">{{ approvalContent.variables.days || 0 }}个自然日</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width:110px">过往累计延期</div>
                        <div class="item-text">{{ approvalContent.variables.sumAdaptDay || 0 }}个自然日</div>
                    </div>
                    <div class="item">
                        <div class="item-title">延期后：</div>
                        <div class="item-text" v-html="changeMsg[1]">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (approvalContent.variables.fileUrls?(approvalContent.variables.fileUrls?.split(',')) : [])"
                                :src="imgItem"
                                @click="photoPreview((approvalContent.variables.fileUrls?(approvalContent.variables.fileUrls?.split(',')) : []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '49'">
                <div class="data-top">
                    <div class="data-content">延期信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">缩减工序：</div>
                        <div class="item-text">{{ approvalContent.variables.processName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">缩减天数：</div>
                        <div class="item-text">{{ approvalContent.variables.adaptDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">累计缩减天数：</div>
                        <div class="item-text">{{ approvalContent.variables.sumAdaptDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <van-image class="item-img"
                                v-for="(imgItem, imgIndex) in (approvalContent.variables.fileUrls?(approvalContent.variables.fileUrls?.split(',')) : [])"
                                :src="imgItem"
                                @click="photoPreview((approvalContent.variables.fileUrls?(approvalContent.variables.fileUrls?.split(',')) : []), imgIndex)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '52'">
                <div class="data-top">
                    <div class="data-content">动工信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">开工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.startDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">动工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.actualStartDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">实际日期：</div>
                        <div class="item-text">{{ approvalContent.variables.actualDatePeriods }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">调整原因：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in (approvalContent.variables.picInfo?.split(',') || [])"
                                    :src="imgItem"
                                    @click="photoPreview((approvalContent.variables.picInfo?.split(',') || []), imgIndex)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '1' && approvalContent.variables.var11 && 
                        (approvalContent.variables.var11 === '中期款' || approvalContent.variables.var11 === '尾期款' 
                        || approvalContent.variables.var11 === '尾期后变更款')">
                <div class="data-top" @click="() => isShowDetail = !isShowDetail">
                <div class="data-content">审批内容</div>
                <div class="data-icon">
                    <van-icon v-if="!isShowData" size="14px" name="arrow-down" />
                    <van-icon v-else size="14px" name="arrow-up" />
                </div>
                </div>
                <div v-if="isShowDetail">
                    <div class="item">
                        <div class="item-title1">款项类型</div>
                        <div class="item-text">{{ planDetail?.paymentTypeName || '-' }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title1">客户已交金额</div>
                        <div class="item-text">{{ planDetail?.amountTotalReceived || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '中期款'">
                        <div class="item-title1">合同中期款</div>
                        <div class="item-text">{{ planDetail?.referenceAmount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期款'">
                        <div class="item-title1">合同尾期款</div>
                        <div class="item-text">{{ planDetail?.referenceAmount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期后变更款'">
                        <div class="item-title1">尾期后变更款</div>
                        <div class="item-text">{{ planDetail?.originalChangeAmount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '中期款' || (approvalContent.variables.var11 === '尾期款' && planDetail?.paymentCount == 2)">
                        <div class="item-title1">首期款多交金额</div>
                        <div class="item-text">{{ planDetail?.morePrice || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期款' && planDetail?.paymentCount == 3">
                        <div class="item-title1">中期款多交金额</div>
                        <div class="item-text">{{ planDetail?.morePrice || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期后变更款' && planDetail?.paymentCount != 1">
                        <div class="item-title1">尾期款多交金额</div>
                        <div class="item-text">{{ planDetail?.morePrice || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期后变更款' && planDetail?.paymentCount == 1">
                        <div class="item-title1">一次性工程款多交金额</div>
                        <div class="item-text">{{ planDetail?.morePrice || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '中期款'">
                        <div class="item-title1">中期变更款</div>
                        <div class="item-text">{{ planDetail?.changePrice || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期款'">
                        <div class="item-title1">尾期变更款</div>
                        <div class="item-text">{{ planDetail?.changePrice || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '中期款'">
                        <div class="item-title1">中期(优惠)公司承担部分</div>
                        <div class="item-text">{{ planDetail?.companyDiscount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '中期款'">
                        <div class="item-title1">中期(优惠)责任人承担部分</div>
                        <div class="item-text">{{ planDetail?.personalDiscount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期款'">
                        <div class="item-title1">尾期(优惠)公司承担部分</div>
                        <div class="item-text">{{ planDetail?.companyDiscount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期款'">
                        <div class="item-title1">尾期(优惠)责任人承担部分</div>
                        <div class="item-text">{{ planDetail?.personalDiscount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期后变更款'">
                        <div class="item-title1">尾期后(优惠)公司承担部分</div>
                        <div class="item-text">{{ planDetail?.companyDiscount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期后变更款'">
                        <div class="item-title1">尾期后(优惠)责任人承担部分</div>
                        <div class="item-text">{{ planDetail?.personalDiscount || 0 }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title1">[优惠]合计</div>
                        <div class="item-text">{{ planDetail?.totalDiscount || 0 }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '中期款'">
                        <div class="item-title1">中期备注说明</div>
                        <div class="item-text">{{ planDetail?.remark || '-' }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期款'">
                        <div class="item-title1">尾期备注说明</div>
                        <div class="item-text">{{ planDetail?.remark || '-' }}</div>
                    </div>
                    <div class="item" v-if="approvalContent.variables.var11 === '尾期后变更款'">
                        <div class="item-title1">尾期后变更款备注说明</div>
                        <div class="item-text">{{ planDetail?.remark || '-' }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title1">公司应收金额</div>
                        <div class="item-text">{{ planDetail?.companyAmountReceivable || 0 }}</div>
                    </div>
                    <div class="item textBold">
                        <div class="item-title1">计划收款金额</div>
                        <div class="item-text">{{ planDetail?.paymentAmount || 0 }}</div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '1' && approvalContent.variables.var11 
                        && (approvalContent.variables.var11 === '增项款交款（一）' 
                        || approvalContent.variables.var11 === '增项款交款（二）')">
                <div class="data-top" @click="() => isShowDetail = !isShowDetail">
                <div class="data-content">审批内容</div>
                <div class="data-icon">
                    <van-icon v-if="!isShowData" size="14px" name="arrow-down" />
                    <van-icon v-else size="14px" name="arrow-up" />
                </div>
                </div>
                <div v-if="isShowDetail">
                    <div v-if="(planDetail?.oldOrNew == '0')">
                        <div class="item">
                            <div class="item-title1">款项类型</div>
                            <div class="item-text">{{ planDetail?.paymentTypeName || '-' }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title1">客户已交金额</div>
                            <div class="item-text">{{ planDetail?.amountTotalReceived || 0 }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title1">备注</div>
                            <div class="item-text">{{ planDetail?.remark || '-' }}</div>
                        </div>
                        <div class="item textBold">
                            <div class="item-title1">收费金额</div>
                            <div class="item-text">{{ planDetail?.paymentAmount || 0 }}</div>
                        </div>
                    </div>
                    <div v-if="(planDetail?.oldOrNew == '1')">
                        <div class="item">
                            <div class="item-title1">款项类型</div>
                            <div class="item-text">{{ planDetail?.paymentTypeName || '-' }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title1">客户已交金额</div>
                            <div class="item-text">{{ planDetail?.amountTotalReceived || 0 }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title1">收费套餐包</div>
                            <div class="item-text">{{ planDetail?.budgetComboName || '-' }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title1">备注</div>
                            <div class="item-text">{{ planDetail?.remark || '-' }}</div>
                        </div>
                        <div class="item textBold">
                            <div class="item-title1">收费金额</div>
                            <div class="item-text">{{ planDetail?.paymentAmount || 0 }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '51'">
                <div class="data-top">
                    <div class="data-content">审批内容</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">申诉理由：</div>
                        <div class="item-text">{{ approvalContent.variables.principalRemark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片证明：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in (approvalContent.variables.principalImgUrlsStr ? JSON.parse(approvalContent.variables.principalImgUrlsStr) : [])"
                                    :src="imgItem.fileUrl"
                                    @click="photoPreview((JSON.parse(approvalContent.variables.principalImgUrlsStr).map(e => e.fileUrl) || []), imgIndex)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '53'">
                <div class="data-top">
                    <div class="data-content">审批内容</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">申请原因：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片证明：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in (approvalContent.variables.picInfo ? approvalContent.variables.picInfo.split(',') : [])"
                                    :src="imgItem"
                                    @click="photoPreview((approvalContent.variables.picInfo ? approvalContent.variables.picInfo.split(',') : []), imgIndex)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '54'">
                <div class="data-top">
                    <div class="data-content">审批内容</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">增加环节：</div>
                        <div class="item-text">{{ approvalContent.variables.processName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">增加位置：</div>
                        <div class="item-text">{{ approvalContent.variables.preProcessName ?
                            approvalContent.variables.preProcessName + ' 工序后' : '' }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">增加天数：</div>
                        <div class="item-text">{{ approvalContent.variables.adaptDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">总工期：</div>
                        <div class="item-text">{{ approvalContent.variables.durationDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">累计增加天数：</div>
                        <div class="item-text">{{ approvalContent.variables.sumAdaptDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">原因说明：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片证明：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in (approvalContent.variables.fileUrls ? approvalContent.variables.fileUrls.split(',') : [])"
                                    :src="imgItem"
                                    @click="photoPreview((approvalContent.variables.fileUrls ? approvalContent.variables.fileUrls.split(',') : []), imgIndex)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 停工 -->
            <div class="card" v-if="businessType == '55'">
                <div class="data-top">
                    <div class="data-content">审批内容</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">停工工序：</div>
                        <div class="item-text">{{ approvalContent.variables.processName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">停工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.planStartDateStr }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 165px;">停工天数(自然日)：</div>
                        <div class="item-text">{{ approvalContent.variables.delayDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">预计复工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.actualStartDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">停工周期：</div>
                        <div class="item-text">{{ approvalContent.variables.actualDatePeriods }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">面积：</div>
                        <div class="item-text">{{ approvalContent.variables.areaAty }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">工期时间：</div>
                        <div class="item-text">{{ approvalContent.variables.durationDays }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in approvalContent.variables.picInfoList"
                                    :src="imgItem.fileUrl"
                                    @click="photoPreview(approvalContent.variables.picInfoList?.map(e => e.fileUrl), imgIndex)" />
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                </div>
            </div>
            <!-- 延长停工 -->
            <div class="card" v-if="businessType == '56'">
                <div class="data-top">
                    <div class="data-content">现停工信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">停工周期：</div>
                        <div class="item-text">{{ approvalContent.variables.currentActualDatePeriods }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">停工天数：</div>
                        <div class="item-text">{{ approvalContent.variables.currentDelayDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">预计复工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.currentActualStartDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">停工工序：</div>
                        <div class="item-text">{{ approvalContent.variables.processName }}</div>
                    </div>
                </div>
                <div class="data-top">
                    <div class="data-content">审批内容</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">延长天数：</div>
                        <div class="item-text">{{ (approvalContent.variables?.delayDay &&
                            approvalContent.variables?.currentDelayDay) ? approvalContent.variables?.delayDay -
                            approvalContent.variables?.currentDelayDay:'-'
                            }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">停工天数：</div>
                        <div class="item-text">{{ approvalContent.variables.delayDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 165px;">复工日期延长至：</div>
                        <div class="item-text">{{ approvalContent.variables.actualStartDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 165px;">延期后停工周期：</div>
                        <div class="item-text">{{ approvalContent.variables.actualDatePeriods }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in approvalContent.variables.picInfoList"
                                    :src="imgItem.fileUrl"
                                    @click="photoPreview(approvalContent.variables.picInfoList?.map(e => e.fileUrl), imgIndex)" />
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                </div>
            </div>
            <!-- 提前开工 -->
            <div class="card" v-if="businessType == '57'">
                <div class="data-top">
                    <div class="data-content">审批内容</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">提前开工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.planStartDateStr }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">预计动工日期：</div>
                        <div class="item-text">{{ approvalContent.variables.actualStartDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 165px;">所差天数(自然日)：</div>
                        <div class="item-text">{{ approvalContent.variables.delayDay }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片证明：</div>
                        <!-- <div class="item-text">{{ approvalContent.variables.assignableCause }}</div> -->
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in approvalContent.variables.picInfoList"
                                    :src="imgItem.fileUrl"
                                    @click="photoPreview(approvalContent.variables.picInfoList?.map(e => e.fileUrl), imgIndex)" />
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                </div>
            </div>
            <!-- 开工日期延期 -->
            <div class="card" v-if="businessType == '61'">
                <div class="data-top">
                    <div class="data-content">客户信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">客户姓名：</div>
                        <div class="item-text">{{ approvalContent.variables?.customerName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">合同号：</div>
                        <div class="item-text">{{ approvalContent.variables?.contractNo }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">装修地址：</div>
                        <div class="item-text">{{ approvalContent.variables?.detailAddress }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">面积：</div>
                        <div class="item-text">{{ approvalContent.variables?.areaAty }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">订单类型：</div>
                        <div class="item-text">{{ approvalContent.variables?.orderPriceType == '1' ? '全包' : '半包'  }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">总工期：</div>
                        <div class="item-text">{{ approvalContent.variables?.planDurationDays }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 120px;">现开工日期：</div>
                        <div class="item-text">{{ approvalContent.variables?.planStartDateStr }}</div>
                    </div>
                </div>
                <div class="data-top">
                    <div class="data-content">开工日期延期信息</div>
                </div>
                <div>
                    <div class="item">
                        <div class="item-title">延期天数：</div>
                        <div class="item-text">{{ approvalContent.variables?.delayDay || 0 }}个工作日</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 100px;">新开工日期：</div>
                        <div class="item-text">{{ approvalContent.variables?.actualStartDate }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 100px;">延期后工期：</div>
                        <div class="item-text">{{ approvalContent.variables?.actualDatePeriods }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">图片证明：</div>
                        <div>
                            <div>
                                <van-image class="item-img"
                                    v-for="(imgItem, imgIndex) in approvalContent.variables.picInfoList"
                                    :src="imgItem.fileUrl"
                                    @click="photoPreview(approvalContent.variables.picInfoList?.map(e => e.fileUrl), imgIndex)" />
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注：</div>
                        <div class="item-text">{{ approvalContent.variables.remark }}</div>
                    </div>
                </div>
            </div>
            <!-- 自理销售退款 -->
            <div class="card" v-if="businessType == '19'">
                <div class="data-top" @click="() => isShowData19 = !isShowData19">
                    <div class="data-content">退款信息</div>
                    <div class="data-icon">
                        <van-icon v-if="!isShowData19" size="14px" name="arrow-down" />
                        <van-icon v-else size="14px" name="arrow-up" />
                    </div>
                </div>
                <div v-if="isShowData19">
                    <div class="content content19-">
                        <div class="item">
                            <div class="item-title">合同金额：</div>
                            <div class="item-text">{{ (basicInfo.contractSum || 0).toFixed(2) }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">变更金额：</div>
                            <div class="item-text">{{ (basicInfo.changeSum || 0).toFixed(2) }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">责任人承担金额：</div>
                            <div class="item-text">{{ (basicInfo.adjectiveSum || 0).toFixed(2) }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">已缴金额：</div>
                            <div class="item-text">{{ (basicInfo.paidSum || 0).toFixed(2) }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">溢缴金额：</div>
                            <div class="item-text">{{ (basicInfo.overpaySum || 0).toFixed(2) }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">本次退款金额：</div>
                            <div class="item-text">{{ (basicInfo.refundSum || 0).toFixed(2) }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">退款原因：</div>
                            <div class="item-text">{{ basicInfo.refundRemark }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 项目经理修改个人承接区域审批 -->
            <div  v-if="businessType == '79'">
                <div class="card" >
                    <div class="data-top" @click="() => isShowData = !isShowData">
                        <div class="data-content" id="common-basic-info-845782">基本资料</div>
                        <div class="data-icon">
                            <van-icon v-if="isShowData" size="14px" name="arrow-down" />
                            <van-icon v-else size="14px" name="arrow-up" />
                        </div>
                    </div>
                    <div class="content content19-" v-if="!isShowData">
                        <div class="item">
                            <div class="item-title">深化名称：</div>
                            <div class="item-text">{{ (approvalContent.variables.projectManagerName || '-')}}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">等级：</div>
                            <div class="item-text">{{ approvalContent.variables.level || '-'}}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">在建工地：</div>
                            <div class="item-text">{{ approvalContent.variables.numberUnderConstruction || '-'}}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">原承接区域：</div>
                            <div class="item-text">{{ (approvalContent.variables.oldUndertakingAreaName || '-').replace(/,/g, '、')}}</div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="data-top">
                        <div class="data-content">审核内容</div>
                    </div>
                    <div class="content content19-">
                        <div class="item">
                            <div class="item-title">调整后承接区域：</div>
                            <div class="item-text">{{ (approvalContent.variables.newUndertakingAreaName || '-').replace(/,/g, '、')}}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">调整原因：</div>
                            <div class="item-text">{{ approvalContent.variables.adjustmentReason}}</div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- 额外优惠 -->
            <div class="card" v-if="businessType == '68' || businessType == '69'">
                <div class="data-top" @click="() => isShowData = !isShowData">
                    <div class="data-content">客户资料<span style="color: #efefef;font-size: 14px;">（点击展开）</span></div>
                    <div class="data-icon">
                        <van-icon v-if="!isShowData" size="14px" name="arrow-down" />
                        <van-icon v-else size="14px" name="arrow-up" />
                    </div>
                </div>
                <div v-if="isShowData">
                    <div class="content">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ basicInfo.consumerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ basicInfo.maintainContract }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ (basicInfo.cityCode || '') + (basicInfo.detailAddress || '')}}</div>
                        </div>
                        <div class="item" v-if="businessType == '0'">
                            <div class="item-title">面积：</div>
                            <div class="item-text">{{ basicInfo.areaQty }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">订单进度：</div>
                            <div class="item-text">{{ basicInfo.orderProcess }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">套餐：</div>
                            <div class="item-text">{{ basicInfo.templatePackageLevelNames }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title" style="width: 130px;">工程合同价：</div>
                            <div class="item-text">{{ basicInfo.contractPrice }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '70' || businessType == '71'">
                <div class="data-top" @click="() => isShowData = !isShowData">
                    <div class="data-content">基本资料<span style="color: #efefef;font-size: 14px;"></span></div>
                    <div class="data-icon">
                        <van-icon v-if="!isShowData" size="14px" name="arrow-down" />
                        <van-icon v-else size="14px" name="arrow-up" />
                    </div>
                </div>
                <div v-if="isShowData">
                    <div class="content">
                        <div class="item">
                            <div class="item-title">客户姓名：</div>
                            <div class="item-text">{{ basicInfo.consumerName }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">合同号：</div>
                            <div class="item-text">{{ basicInfo.maintainContract }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">装修地址：</div>
                            <div class="item-text">{{ (basicInfo.cityCode || '') + (basicInfo.detailAddress || '') }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title">套餐：</div>
                            <div class="item-text">{{ basicInfo.templatePackageLevelNames }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title" style="width: 130px;">工程合同价：</div>
                            <div class="item-text">{{ basicInfo.contractPrice }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" v-if="businessType == '68' || businessType == '69'">
                <div class="approval-top">
                    <div class="approval-content">审批内容</div>
                </div>
                <div class="content"  v-if="approvalContent.variables?.businessType == '69'">
                    <div class="item">
                        <div class="item-title">撤销原因：</div>
                        <div class="item-text">{{ approvalContent.variables.revokeReason || '-' }}</div>
                    </div>
                </div>
                <div class="content" v-if="approvalContent.variables?.extraDiscountAmountType == '0'">
                    <div class="item">
                        <div class="item-title">优惠金额：</div>
                        <div class="item-text">{{approvalContent.variables?.extraFavourList?.[0]?.favourTotal || 0}}元</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 140px;">原工程合同价：</div>
                        <div class="item-text">{{approvalContent.variables?.extraFavourList?.[0]?.originalOrderContractPrice || 0}}元</div>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: 190px;">优惠后工程合同价：</div>
                        <div class="item-text">{{approvalContent.variables?.extraFavourList?.[0]?.favourOrderContractPrice || 0}}元</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注信息：</div>
                        <div class="item-text">{{ approvalContent.variables?.remark || '-' }}</div>
                    </div>
                </div>
                <div class="content" v-else>
                    <div>
                        <el-table :data="tableData" style="width: 100%" v-if="tableData.length>0">
                            <el-table-column
                                type="index"
                                label="序号"
                                align="center"
                                width="60"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="packageLevelName"
                                label="套餐包" >
                            </el-table-column>
                            <el-table-column
                                prop="favourTotal"
                                label="优惠金额">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="item">
                        <div class="item-title" style="width: auto;">原{{ approvalContent.variables?.isInsp != '1' ? '工程合同' : '订购' }}价：</div>
                        <div class="item-text" style="width: auto;">{{approvalContent.variables?.extraFavourList?.[0]?.originalOrderContractPrice || 0}}元</div>
                    </div>
                    <div class="item" v-for="item in approvalContent.variables?.extraFavourList.filter(item => item.packageLevelName!='合计')">
                        <div class="item-title" style="width: auto;">原{{item.packageLevelName}}：</div>
                        <div class="item-text" style="width: auto;">{{item.contractPrice || 0}}元</div>
                    </div>
                    <div style="border: 1px solid #E6E6E6;"></div>
                    <div class="item">
                        <div class="item-title" style="width: auto;">优惠后{{ approvalContent.variables?.isInsp != '1' ? '工程合同' : '订购' }}价：</div>
                        <div class="item-text" style="width: auto;">{{approvalContent.variables?.extraFavourList?.[0]?.favourOrderContractPrice || 0}}元</div>
                    </div>
                    <div class="item" v-for="item in approvalContent.variables?.extraFavourList.filter(item => item.packageLevelName!='合计')">
                        <div class="item-title" style="width: auto;">优惠后{{item.packageLevelName}}：</div>
                        <div class="item-text" style="width: auto;">{{item.favourContractPrice || 0}}元</div>
                    </div>
                    <div class="item">
                        <div class="item-title">备注信息：</div>
                        <div class="item-text">{{ approvalContent.variables?.remark || '-' }}</div>
                    </div>
                </div>

            </div>
            <div class="card" v-if="businessType == '70' || businessType == '71'">
                <div class="data-top" @click="() => isShowDetail = !isShowDetail">
                    <div class="data-content">审批内容</div>
                    
                    <div class="data-icon">
                        <van-icon v-if="!isShowDetail" size="14px" name="arrow-down" />
                        <van-icon v-else size="14px" name="arrow-up" />
                    </div>
                </div>
                <div v-if="isShowDetail">
                    <div class="content" v-if="approvalContent.variables?.businessType == '71'">
                        <div class="item">
                            <div class="item-title">撤销原因：</div>
                            <div class="item-text">{{ approvalContent.variables.revokeReason || '-' }}</div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="item">
                            <div class="item-title">赠送套餐包：</div>
                            <div class="item-text">{{ approvalContent.variables.packageLevelName || '-' }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title" style="width: 200px;">套餐包赠送上限金额：</div>
                            <div class="item-text">{{ approvalContent.variables.maxGiftCostAmount || 0 }}</div>
                        </div>
                        <div class="item">
                            <div class="item-title" style="width: 180px;">赠送商品成本金额：</div>
                            <div class="item-text">
                                {{ approvalContent.variables?.costTotal || '0' }}
                                <span
                                    v-if="parseFloat(approvalContent.variables?.costTotal || 0) > parseFloat(approvalContent.variables?.maxGiftCostAmount || 0)">
                                    （超出成本上限 <span style="color:#D9001B">{{ (parseFloat(approvalContent.variables?.costTotal || 0) - parseFloat(approvalContent.variables?.maxGiftCostAmount || 0)).toFixed(2) }}</span>元）
                                </span>
                            </div>
                        </div>
                        <div class="gift-table">
                            <div class="table-title">商品详情</div>
                            <div class="table-header">
                                <div class="th">序号</div>
                                <div class="th">商品名称</div>
                                <div class="th">单位</div>
                                <div class="th">数量</div>
                            </div>
                            <div class="table-row"
                                v-for="(item, index) in approvalContent.variables.itemList" :key="index">
                                <div class="td">{{ index + 1 }}</div>
                                <div class="td">{{ item.quotaName || '-' }}</div>
                                <div class="td">{{ item.unitName || '-' }}</div>
                                <div class="td">{{ item.quotaNum || 0 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="approval-top">
                    <div class="approval-content">审批流程</div>
                </div>
                <div v-if="nodeInfo.length">
                    <van-steps direction="vertical" :active="activeStepCount()"
                        active-color="#0066FF" class="steps">
                        <van-step v-for="(item, index) in nodeInfo" :key="index">
                            <template #active-icon>
                                <span class="step-icon">{{ item.approveNodeType == 2 ? '审' : '抄' }}</span>
                            </template>
                            <template #inactive-icon>
                                <span class="step-icon step-icon-inactive">{{ item.approveNodeType == 2 ? '审' : '抄' }}</span>
                            </template>
                            <div class="step-name">
                                <span class="step-node-type">{{ item.approveNodeType == 2 ? '审批人' : '抄送人' }}</span>
                                <van-tag v-if="item.approveStatus === 0" type="primary" plain>审批中</van-tag>
                                <van-tag v-if="item.approveStatus === 1" type="success" plain>已通过</van-tag> 
                                <van-tag v-if="item.approveStatus === 2" type="danger" plain>已拒绝</van-tag>
                                <van-tag v-if="item.approveStatus === 3" type="success" plain>已抄送</van-tag>
                                <div class="step-time" v-if="item.approveDate">{{ item.approveDate }}</div>
                            </div>
                            <div class="step-content">{{ item.approveUserNameList && item.approveUserNameList.join('、') }}</div>
                            
                            <div class="step-remark" v-if="item.approveRemark">审批意见：{{ item.approveRemark }}</div>
                        </van-step>
                    </van-steps>
                </div>
            </div>
        </div>
        <div class="footer" v-if="noticeType == '1' && messageType != '33'">
            <template v-if="canApprove()">
                <div :class="[approvalContent.variables.cancel ? 'refuseE' : 'refuse', approvalDisabled ? 'disabled-btn' : '']" @click="!approvalDisabled && handApproval(false)">拒绝</div>
                <div :class="[approvalContent.variables.cancel ? 'refuseE' : 'agree', approvalDisabled ? 'disabled-btn' : '']" @click="!approvalDisabled && handApproval(true)">同意</div>
            </template>
            <div v-else class="no-action-tip">当前审批阶段您无需操作</div>
        </div>
        <div class="footer"  v-else>
            <div class="no-action-tip">当前审批阶段您无需操作。</div>
        </div>
        <van-dialog v-model="approvalDialog" show-cancel-button :before-close="dialogSubmit"
            confirmButtonColor="#1989fa">
            <template #title>
                <div class="dialog-title">审批意见<span style="color: red;">*</span></div>
            </template>
            <div style="padding: 10px 20px;">
                <van-field v-model="approvalOpinion" rows="2" autosize type="textarea" required :maxlength="maxlength"
                    placeholder="​请输入审批意见" show-word-limit />
            </div>
        </van-dialog>
    </div>
</template>

<script>
import api from '../../api/api.js'
import {
    Toast, ImagePreview
} from 'vant';
export default {
    data () {
        return {
            isShowData: false,
            isShowData19: false,
            approvalDialog: false,
            approvalOpinion: '',//审批意见
            businessType: '',//单据类型
            noticeType: '',//通知类型0审批通知 1审批通过 2审批拒绝
            bussinessId: '',
            procInstanceId: '',
            basicInfo: {},//基本信息
            materialApplyInfo: {},//辅材申领客户信息
            approvalContent: {
                variables: {}
            },//审批内容
            materialsList: [],//材料列表
            approvalResult: '',//审批结果
            approverUserInfo: {},//下一步审批人信息
            messageId: '',//消息id
            maxlength: 120,
            messageType:'',
            changeMsg:[
                '',
                '',
                ''
            ],
            tableData: [],
            planDetail: {},
            isShowDetail: false,
            nodeInfo: [], // 审批路由节点信息
            approvalDisabled: false, // 审批按钮禁用状态
            idName: '', // 当前审批人标识，与taskDTO平级
        }
    },
    methods: {
        // 判断当前用户是否可审批
        canApprove () {
            if (!this.idName) return false
            const approvingNode = this.nodeInfo.find(item => item.approveStatus == 0)
            if (!approvingNode || !approvingNode.approveUserNameList) return false
            return approvingNode.approveUserNameList.includes(this.idName)
        },
        // 计算步骤条高亮位置：审批中的节点为当前步骤，之前的为已完成
        activeStepCount () {
            const processingIndex = this.nodeInfo.findIndex(item => item.approveStatus === 0)
            return processingIndex !== -1 ? processingIndex : this.nodeInfo.length
        },
        //审批
        handApproval (v) {
            this.approvalDisabled = true
            if (!this.approvalContent.variables.cancel) {
                if (this.businessType == '19') {
                    this.maxlength = 50
                }
                this.approvalOpinion = ''
                this.approvalDialog = true
                this.approvalResult = v ? "yes" : "no"
            }
        },
        //审批提交
        async dialogSubmit (action, done) {
            if (action === 'confirm') { // 确认
                if (!this.approvalOpinion.trim().length) {
                    Toast.fail('请输入审批意见')
                    done(false)
                    return
                }
                let obj = {
                    procInstId: this.approvalContent.procInstId,//流程实例id
                    taskId: this.approvalContent.taskId,//当前任务id
                    taskName: this.approvalContent.taskName,
                    variables: {
                        is: this.approvalResult,//no拒绝，yes 同意
                        reason: this.approvalOpinion,
                        history: this.approvalContent.variables.history,
                        businessId: this.approvalContent.variables.businessId,
                        pass: this.approvalContent.variables.pass,
                    },
                    startTaskUserId: this.approvalContent.startTaskUserId,
                    startTaskUserName: this.approvalContent.startTaskUserName,
                    businessKey: this.approvalContent.businessKey,
                }
                //不是辅材的情况
                if (this.businessType != '11') {
                    obj = {
                        procInstId: this.approvalContent.procInstId,//流程实例id
                        taskId: this.approvalContent.taskId,//当前任务id
                        taskName: this.approvalContent.taskName,
                        variables: {
                            ...this.approvalContent?.variables,
                            is: this.approvalResult,//拒绝，yes 同意
                            reason: this.approvalOpinion,
                            history: this.approvalContent.variables.history,
                            businessId: this.approvalContent.variables.businessId,
                            pass: this.approvalContent.variables.pass,
                        },
                        defineUserId: this.approverUserInfo.accountId ? this.approverUserInfo.accountId[0] : undefined,
                        defineGroupIdList: this.approverUserInfo.groupIds ? this.approverUserInfo.groupIds : undefined,
                        updateUserId: this.approverUserInfo.accountId ? this.approverUserInfo.accountId[0] : undefined,
                        updateGroupIdList: this.approverUserInfo.groupIds && this.businessType != '2' ? this.approverUserInfo.groupIds : undefined,
                        accountIdList: this.approverUserInfo.accountIdList ? this.approverUserInfo.accountIdList : undefined,
                        updateAccountIdList: undefined,
                        startTaskUserId: this.approvalContent.startTaskUserId,
                        startTaskUserName: this.approvalContent.startTaskUserName,
                        businessKey: this.approvalContent.businessKey,
                    }
                }
                try {
                    let res = await api.approvalSubmit(obj)
                    if (res.code == 200) {
                        if (!res.success) {
                            Toast.fail(res.msg)
                        } else {
                            Toast.success('操作成功！')
                        }
                        this.getApprovalContent()
                        done()
                    }
                } catch (error) {
                    done()
                    this.getApprovalContent()
                }
            } else if (action === 'cancel') { // 取消
                done(); // 关闭提示框
            }
        },
        //获取审批详情
        async getApprovalDetails () {
            let filterArr = ['0', '1', '2', '3', '4', '7', '14', '15', '16', '17', '18','19', '35','68','69','70','71']
            if (filterArr.indexOf(this.businessType)==-1) return
            if (this.businessType == '19') {
                let res = await api.approvalDetails3(this.approvalContent.variables)
                if (res.code == 200) {
                    this.basicInfo = res.data
                }
                return
            }
            let res = await api.approvalDetails(this.approvalContent.businessKey)
            if (res.code == 200) {
                this.basicInfo = res.data
            }
        },
        //获取审批内容
        async getApprovalContent () {
            let obj = {
                noticeType: this.$route.query.approvalNoticeType,
                procInstanceId: this.procInstanceId,
                msgId: this.messageId
            }
            let res = await api.approvalContent(obj)
            if (res.code == 200) {

                let noticeType2 
                //当res.data.taskDTO.isEnd 为数字0时候会被判为true，需要特殊处理
                if((res.data.taskDTO.isEnd ?? 'xxplace') == 'xxplace'){
                    noticeType2 = res.data.noticeType
                }else{
                    noticeType2 = res.data.taskDTO.isEnd == 0 ? '1' : res.data.taskDTO.isEnd == 1 ? '2' : '3'
                }
                this.noticeType = noticeType2


                if (res.data.taskDTO) this.approvalContent = res.data.taskDTO
                this.idName = res.data.idName || '' // 当前审批人标识，与taskDTO平级
                console.log(this.approvalContent,'this.approvalContent')
                if (this.approvalContent.variables?.businessType == '54' || this.approvalContent.variables?.businessType == '48' || this.approvalContent.variables?.businessType == '49') this.getProcessChangeInfo()
                if(this.approvalContent.variables?.businessType == '68' || this.approvalContent.variables?.businessType == '69'){
                    let list = JSON.parse(JSON.stringify(this.approvalContent.variables?.extraFavourList || []));
                    let sum = 0;
                    list.forEach(element => {
                        sum += element.favourTotal;
                    });
                    list.push({
                        packageLevelName: '合计',
                        favourTotal: sum,
                    })
                    this.tableData = list
                }
            }
            // 同步调用审批路由选项列表
            let approveRouteRes = await this.getNodeInfo(res.data)
            if (approveRouteRes && approveRouteRes.code == 200) {
                this.nodeInfo = approveRouteRes.data || []
            }
            console.log('approveRouteOptionList 返回结果:', approveRouteRes)
        },
        // 获取审批路由选项列表
        async getNodeInfo (data2) {
            let data = data2.taskDTO
            let routeParams = {
                flowType: data.variables?.businessType == '13' ? '35' : data.variables?.businessType,
                routeType: data.variables?.flowBranchType || '1',
                marketCode: data.variables?.marketCode,
                constructionId: data.variables?.constructionId || data.variables?.id,
                procInstanceId: data.procInstId,
                applyDate: data.createDate,
            }
            if (routeParams.flowType == 2) {
                routeParams.flowName = data?.procDefName
            }
            // if ([14, 16, 17, 18, 57, 11].includes(routeParams.flowType)) {
            //     routeParams.orderId = data.variables?.orderId
            // }
            routeParams.orderId = data.variables?.orderId
            if (routeParams.flowType == 62) {
                routeParams.followFansId = data.variables?.followFansId
            }
            let res2 = await api.approveRouteOptionList(routeParams)
            return res2
        },
        //获取辅材详情
        async getMaterialsDetails () {
            let obj = {
                Q_applyId_EQ: this.approvalContent.variables.applyId
            }
            let res = await api.getMaterialsDetails(obj)
            if (res.code == 200) {
                this.materialsList = res.data
            }
        },
        //获取辅材申领客户详情
        async getMaterialApplyCustomersInfo () {
            let res = await api.findMaterialApplyCustomersInfo(this.approvalContent.variables.orderId)
            if (res.code == 200) {
                this.materialApplyInfo = res.data
            }
        },
        //获取收款计划详情
        async paymentReceipt () {
            let obj = {
                id: this.approvalContent.variables.var10
            }
            let res = await api.paymentReceipt(obj)
            if (res.code == 200) {
                this.planDetail = res.data
            }
        },
        //图片预览
        photoPreview (url, index) {
            if (!url.length) return
            ImagePreview({
                images: url,
                startPosition: index || 0,
            });
        },
        //查询下一步审批人员
        async checkPeo () {
            let res = await api.checkPeo({ processInstanceId: this.procInstanceId, stepType: 'now', weChatFlag: '1' })
            if (res.code == 200) {
                this.approverUserInfo = res.data
            }
        },
        //获取工序变更信息
        getProcessChangeInfo(){
            const adaptGoalCodes = {
                '48': '1',
                '49': '0',
                '54': '2'
            }
            let adaptGoalCode = adaptGoalCodes[this.$route.query.businessType]
        if (adaptGoalCode == '0') {
            this.changeMsg[adaptGoalCode] = `
            <div>【${this.approvalContent.variables.processName}】环节从工程进度中移除</div>
            <div>总工期不变</div>
            <div>应完工日期不变</div>
            <div>应交付日期不变</div>
            `
            return
        }
        let res = this.approvalContent.variables.durationsVO || {}
        if (adaptGoalCode == '1') {
            this.changeMsg[adaptGoalCode] = `
            <div>【${this.approvalContent.variables.processName}】环节由【${res.oldProcessDay}】个工作日增加至【${res.newProcessDay}】个工作日</div>
            <div>总工期增加【${res.oldDurationDay}】个工作日至【${res.newDurationDay}】工作日</div>
            <div>【${this.approvalContent.variables.processName}】环节预计完成时间由【${res.oldTargetEndDate}】延期至【${res.newTargetEndDate}】</div>
            <div>应完工日期由【${res.oldTargetFinishDate}】延期至【${res.newTargetFinishDate}】</div>
            <div>应交付日期由【${res.oldTargetTransferDate}】延期至【${res.newTargetTransferDate}】</div>
            `
        }
        if (adaptGoalCode == '2') {
            if (this.approvalContent.variables.isDefer == '1') {
            //工期顺延
            this.changeMsg[adaptGoalCode] = `
            <div>增加【${this.approvalContent.variables.processName}】环节共【${res.dayCount}】工作日</div>
            <div>【${this.approvalContent.variables.processName}】环节预计开始时间为【${res.newTargetStartDate}】，预计完成时间为【${res.newTargetEndDate}】</div>
            <div>总工期增加【${res.dayCount}】个工作日至【${res.newDurationDay}】个工作日 </div>
            <div>应完工日期由【${res.oldTargetFinishDate}】延期至【${res.newTargetFinishDate}】</div>
            <div>应交付日期由【${res.oldTargetTransferDate}】延期至【${res.newTargetTransferDate}】</div>
            `
            } else {
            //工期不顺延
            this.changeMsg[adaptGoalCode] = `
            <div>增加【${this.approvalContent.variables.processName}】环节共【${res.dayCount}】工作日</div>
            <div>【${this.approvalContent.variables.processName}】环节预计开始时间为【${res.newTargetStartDate}】，预计完成时间为【${res.newTargetEndDate}】</div>
            <div>总工期不变</div>
            <div>应完工日期不变</div>
            <div>应交付日期不变</div>
            `
            }

        }
        }
    },
    async created () {
        document.title = '审批详情'
        this.procInstanceId = this.$route.query.procInstanceId
        this.businessType = this.$route.query.businessType
        this.bussinessId = this.businessType == '11' ? this.$route.query.orderId : this.$route.query.bussinessId
        this.messageId = this.$route.query.messageId
        this.messageType = this.$route.query.messageType
        this.checkPeo()
        await this.getApprovalContent()
        await this.getApprovalDetails()
        if (this.businessType == '11') {
            await this.getMaterialsDetails()
            await this.getMaterialApplyCustomersInfo()
        }
        if (this.approvalContent.variables && this.approvalContent.variables.var10){
            await this.paymentReceipt()
        }
    }
}
</script>

<style scoped lang="scss">
.message-box {
    text-align: left;
    height: 100vh;
    background:#f5f5f5;
    .center {
        height: calc(100vh - 80px);
        background: #F5F5F5;
        padding-top: 0.1px;
        overflow: auto;

        .card {
            background: #FFFFFF;
            margin: 8px 0;
            padding-bottom: 0.1px;

        }

        .title {
            height: 64px;
            background: #FFFFFF;
            padding: 4px 16px;
            box-sizing: border-box;
            margin: 8px 0;

            .text-code {
                font-size: 14px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #999999;
                line-height: 14px;
                margin-bottom: 4px;
            }

            .text-content {
                font-size: 18px;
                font-family: PingFang SC-Bold, PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 20px;
            }
        }

        .approval-top,
        .data-top {
            display: flex;
            height: 47px;
            border-bottom: 1px solid #F5F5F5;

            div {
                flex: 1;
                display: flex;
                align-items: center;
                padding: 0 16px;
            }

            .approval-content,
            .data-content {
                font-size: 18px;
                font-family: PingFang SC-Bold, PingFang SC;
                font-weight: bold;
                color: #333333;
            }

            .approval-time,
            .data-icon {
                font-size: 14px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #999999;
                justify-content: end;
            }
        }

        .item {
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            line-height: 20px;
            display: flex;
            padding: 0 16px;
            margin: 16px 0;

            .item-title {
                width: 30%;
                color: #666666;
            }
            .item-title1 {
                width: 100px;
                color: #666666;
                margin-right: 10px;
                text-align: right;
            }

            .item-text {
                color: #333333;
                width: 70%;
                word-wrap: break-word;
                word-break: break-all;
            }

            div:has(.item-img) {
                width: calc(100% - 100px);
                display: flex;
                flex-wrap: wrap;
                gap: 5px;
            }

            .item-img {
                width: 50px;
                height: 50px;
            }
        }

        .content19 .item-title {
            width: 100px;
        }

        .content19- .item-title {
            width: 136px;
        }

        .money {
            font-weight: bold;
            color: #FF8450 !important;
        }

        .over-limit {
            color: #FF8450;
        }

        .gift-table {
            margin: 16px;

            .table-title {
                font-size: 16px;
                color: #666666;
                margin-bottom: 12px;
            }

            .table-header,
            .table-row {
                display: flex;
                text-align: center;
                font-size: 14px;
                line-height: 20px;
            }

            .table-header {
                color: #666666;
                margin-bottom: 8px;
            }

            .table-row {
                color: #333333;
                margin-bottom: 8px;
            }

            .th,
            .td {
                flex: 1;
            }

            .th:nth-child(2),
            .td:nth-child(2) {
                flex: 2;
            }
        }

        .steps {
            width:86%;
            margin:0 4%;
        }

        .step-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background: #0066FF;
            color: #fff;
            font-size: 18px;
            font-weight: bold;
            margin: -6px 0 0 -14px;
        }

        .step-icon-inactive {
            background: #C8C9CC;
        }

        .step-node-type {
            margin-right: 6px;
        }

        .step-name {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            line-height: 16px;
            margin:0 0 8px 30px;
            word-wrap: break-word;
            word-break: break-all;
        }
         .step-content,
         .step-remark{
            font-size: 15px;
            // font-weight: 500;
            color: #666;
            line-height: 16px;
            margin: 0 0 8px 30px;
            word-wrap: break-word;
            word-break: break-all;
        }

        .step-time {
            width: 200px;
            text-align: center;
            position: absolute;
            top: 0;
            left: 35%;
            font-size: 13px;
            // font-weight: 500;
            color: #666666;
        }
    }

    .centerS {
        height: calc(100vh - 80px);
    }

    .footer {
        z-index: 999;
        position: fixed;
        width: 96%;
        padding: 10px 2%;
        bottom: 0;
        display: flex;
        font-size: 16px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        background-color: #FFFFFF;
        gap:10px;
        height: 60px;
        div {
            flex: 1;
            text-align: center;
            // line-height: 64px;
        }

        .refuse {
            background: #ED6F6F;
            border-radius: 50px;
            font-size: 18px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            align-content: center;
            margin: 0;
        }

        .refuseE {
            background: #CECECE;   
        }

        .agree {
            background: #38B865;
            border-radius: 50px;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            align-content: center;

            height: 60px;
            margin: 0;
        }

        .disabled-btn {
            background: #CECECE !important;
            pointer-events: none;
            opacity: 0.7;
        }

        .no-action-tip {
            flex: 1;
            text-align: center;
            font-size: 18px;
            color: #999;
            line-height: 60px;
        }
    }

    .list-item {
        border-bottom: 1px solid #E6E6E6;
        height: 64px;
        display: flex;
        padding: 8px 16px;
        align-items: center;
        box-sizing: border-box;

        .left {
            width: 48px;
            height: 48px;
        }

        .item-center {
            width: calc(100% - 50px);

            .item-bottom,
            .item-top {
                display: flex;
                margin: 0 8px;

                div {
                    flex: 1;
                }

                .item-right {
                    text-align: right;
                }
            }

            .item-top {
                margin-bottom: 4px;
                font-size: 16px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;

                .top-name {
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden; //溢出内容隐藏
                    text-overflow: ellipsis; //文本溢出部分用省略号表示
                    display: -webkit-box; //特别显示模式
                    -webkit-line-clamp: 2; //行数
                    line-clamp: 2;
                    -webkit-box-orient: vertical; //盒子中内容竖直排列
                }
            }

            .item-bottom {
                margin-bottom: 4px;
                font-size: 16px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #999999;
            }
        }

    }
    .textBold{
        font-weight: bold;
        color: #070707;
    }
}
</style>
<style lang="scss">
.message-box {
    .van-step__circle-container {
        width: 14px;
        height: 14px;
        box-sizing: border-box;
        background: #0066FF;
        border: 3px solid #CCDDFF;
        border-radius: 50%;

        .van-step__circle {
            display: none;
        }
    }

    .van-field {
        background: #f2f3f5;
    }
}

.van-step__title {
    position: relative;
}

.van-steps {
    overflow: inherit;
}
</style>